//KB added for Power BI API integration starts 
export const reportId = "ce90eea0-57d9-4249-8429-8a18e473aa41";
export const wspaceId = "6643507a-d35d-4f72-aa16-a61197b8ff1a";
export const authorityUrl = "https://login.microsoftonline.com/common/";
export const powerBiApiUrl = "https://api.powerbi.com/";
export const scopeBase = ["https://analysis.windows.net/powerbi/api/Report.Read.All"];
export const clientId  = "92082249-7471-4cfb-a47f-add6014c0451";
//KB added for Power BI API integration ends


//KB added for MSlogin starts 
export const mstenantid="";
export const msclientid="";
export const msobjectId = "";
export const msclientSecret = "";
//KB added for MSlogin ends
